import * as React from 'react';
import { withDataFetchNivo } from '../hoc/withDataFetchNivo';

const ResponsiveAreaBump = React.lazy(() =>
  import('@nivo/bump').then(module => ({ default: module.ResponsiveAreaBump }))
);

const AreaBumpWidget: React.FC<any> = ({ data }) => {
  const { margin, colors, axisTop, axisBottom, spacing } = data.view;

  return (
    <React.Suspense fallback="loading...">
      <ResponsiveAreaBump
        data={data.data}
        margin={margin}
        spacing={spacing}
        colors={colors}
        blendMode="multiply"
        startLabel="id"
        axisTop={axisTop}
        axisBottom={axisBottom}
      />
    </React.Suspense>
  );
};

export default withDataFetchNivo(AreaBumpWidget);
